module.exports = __webpack_public_path__ + "static/media/TvShowBanner (6).29bffb96.png";